webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_events__);




var NotificationCenter = new __WEBPACK_IMPORTED_MODULE_0_events__["EventEmitter"]();

Object.defineProperty(NotificationCenter, 'off', {
  value: NotificationCenter.removeListener,
  enumerable: true,
  writable: false
});

/* harmony default export */ __webpack_exports__["a"] = (NotificationCenter);

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  loadImages: function loadImages(imgs, callback) {
    var loaded = 0;
    var images = [];
    imgs = Object.prototype.toString.apply(imgs) === '[object Array]' ? imgs : [imgs];
    var inc = function inc() {
      loaded += 1;
      if (loaded === imgs.length && callback) {
        callback(images);
      }
    };
    for (var i = 0; i < imgs.length; i++) {
      images[i] = new Image();
      images[i].onabort = inc;
      images[i].onerror = inc;
      images[i].onload = inc;
      images[i].src = imgs[i];
    }
  },
  getStorageId: function getStorageId() {
    var now = new Date();
    return now.getFullYear() + '-' + now.getMonth();
  },
  getLastStorageId: function getLastStorageId() {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].localStorage.get('lastModified');
  },
  setStorageIdNow: function setStorageIdNow() {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].localStorage.set('lastModified', this.getStorageId());
  }
});

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var k = 'p3Hswx6K7tuk48p99EF3pPA9AWsWBHSa3X3GTjjQeVEDC';

/* harmony default export */ __webpack_exports__["a"] = ({

  encode: function encode(str) {
    if (window.btoa) return window.btoa(unescape(encodeURIComponent(str)));else {
      var Base64 = {
        _keyStr: k, encode: function encode(e) {
          var t = "";
          var n, r, i, s, o, u, a;
          var f = 0;
          e = Base64._utf8_encode(e);
          while (f < e.length) {
            n = e.charCodeAt(f++);
            r = e.charCodeAt(f++);
            i = e.charCodeAt(f++);
            s = n >> 2;
            o = (n & 3) << 4 | r >> 4;
            u = (r & 15) << 2 | i >> 6;
            a = i & 63;
            if (isNaN(r)) {
              u = a = 64;
            } else if (isNaN(i)) {
              a = 64;
            }
            t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a);
          }
          return t;
        }, decode: function decode(e) {
          var t = "";
          var n, r, i;
          var s, o, u, a;
          var f = 0;
          e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "");
          while (f < e.length) {
            s = this._keyStr.indexOf(e.charAt(f++));
            o = this._keyStr.indexOf(e.charAt(f++));
            u = this._keyStr.indexOf(e.charAt(f++));
            a = this._keyStr.indexOf(e.charAt(f++));
            n = s << 2 | o >> 4;
            r = (o & 15) << 4 | u >> 2;
            i = (u & 3) << 6 | a;
            t = t + String.fromCharCode(n);
            if (u != 64) {
              t = t + String.fromCharCode(r);
            }
            if (a != 64) {
              t = t + String.fromCharCode(i);
            }
          }
          t = Base64._utf8_decode(t);
          return t;
        }, _utf8_encode: function _utf8_encode(e) {
          e = e.replace(/\r\n/g, "\n");
          var t = "";
          for (var n = 0; n < e.length; n++) {
            var r = e.charCodeAt(n);
            if (r < 128) {
              t += String.fromCharCode(r);
            } else if (r > 127 && r < 2048) {
              t += String.fromCharCode(r >> 6 | 192);
              t += String.fromCharCode(r & 63 | 128);
            } else {
              t += String.fromCharCode(r >> 12 | 224);
              t += String.fromCharCode(r >> 6 & 63 | 128);
              t += String.fromCharCode(r & 63 | 128);
            }
          }
          return t;
        }, _utf8_decode: function _utf8_decode(e) {
          var t = "";
          var n = 0;
          var r = c1 = c2 = 0;
          while (n < e.length) {
            r = e.charCodeAt(n);
            if (r < 128) {
              t += String.fromCharCode(r);
              n++;
            } else if (r > 191 && r < 224) {
              c2 = e.charCodeAt(n + 1);
              t += String.fromCharCode((r & 31) << 6 | c2 & 63);
              n += 2;
            } else {
              c2 = e.charCodeAt(n + 1);
              c3 = e.charCodeAt(n + 2);
              t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
              n += 3;
            }
          }
          return t;
        }
      };

      return Base64.encode(unescape(encodeURIComponent(str)));
    }
  },

  decode: function decode(str) {
    if (window.atob) return decodeURIComponent(escape(window.atob(str)));else {
      var Base64 = {
        _keyStr: k, encode: function encode(e) {
          var t = "";
          var n, r, i, s, o, u, a;
          var f = 0;
          e = Base64._utf8_encode(e);
          while (f < e.length) {
            n = e.charCodeAt(f++);
            r = e.charCodeAt(f++);
            i = e.charCodeAt(f++);
            s = n >> 2;
            o = (n & 3) << 4 | r >> 4;
            u = (r & 15) << 2 | i >> 6;
            a = i & 63;
            if (isNaN(r)) {
              u = a = 64;
            } else if (isNaN(i)) {
              a = 64;
            }
            t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a);
          }
          return t;
        }, decode: function decode(e) {
          var t = "";
          var n, r, i;
          var s, o, u, a;
          var f = 0;
          e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "");
          while (f < e.length) {
            s = this._keyStr.indexOf(e.charAt(f++));
            o = this._keyStr.indexOf(e.charAt(f++));
            u = this._keyStr.indexOf(e.charAt(f++));
            a = this._keyStr.indexOf(e.charAt(f++));
            n = s << 2 | o >> 4;
            r = (o & 15) << 4 | u >> 2;
            i = (u & 3) << 6 | a;
            t = t + String.fromCharCode(n);
            if (u != 64) {
              t = t + String.fromCharCode(r);
            }
            if (a != 64) {
              t = t + String.fromCharCode(i);
            }
          }
          t = Base64._utf8_decode(t);
          return t;
        }, _utf8_encode: function _utf8_encode(e) {
          e = e.replace(/\r\n/g, "\n");
          var t = "";
          for (var n = 0; n < e.length; n++) {
            var r = e.charCodeAt(n);
            if (r < 128) {
              t += String.fromCharCode(r);
            } else if (r > 127 && r < 2048) {
              t += String.fromCharCode(r >> 6 | 192);
              t += String.fromCharCode(r & 63 | 128);
            } else {
              t += String.fromCharCode(r >> 12 | 224);
              t += String.fromCharCode(r >> 6 & 63 | 128);
              t += String.fromCharCode(r & 63 | 128);
            }
          }
          return t;
        }, _utf8_decode: function _utf8_decode(e) {
          var t = "";
          var n = 0;
          var r = c1 = c2 = 0;
          while (n < e.length) {
            r = e.charCodeAt(n);
            if (r < 128) {
              t += String.fromCharCode(r);
              n++;
            } else if (r > 191 && r < 224) {
              c2 = e.charCodeAt(n + 1);
              t += String.fromCharCode((r & 31) << 6 | c2 & 63);
              n += 2;
            } else {
              c2 = e.charCodeAt(n + 1);
              c3 = e.charCodeAt(n + 2);
              t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
              n += 3;
            }
          }
          return t;
        }
      };

      return decodeURIComponent(escape(Base64.decode(str)));
    }
  }
});

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = {
	"general": {
		"title": "Hello, I’m Kolin Weidmann,<br> freelance front-end developer based in Paris.",
		"description": "# HTML, CSS, JS <br><small>&angrt; Vue.js, Shopify, Prismic, DatoCMS, Wordpress, NPM, Yarn, Webpack, Git, Figma ...</small><br><br><a href=\"mailto:kolin.w@gmail.com\">Get in touch</a>"
	},
	"titles": {
		"top": "TL;DR",
		"projects": "Projects",
		"archives": "Archives",
		"about": "About"
	},
	"projects": [
		{
			"id": "openspaceparis",
			"title": "Open&nbsp;Space&nbsp;Paris",
			"description": "Talent management agency portfolio of portfolios, continuously updated with lots of high quality pictures of their artists. <br> <small>Design and development for <a href=\"https://athom.co/\" target=\"_blank\">Athom</a></small>",
			"live": true,
			"url": "https://openspaceparis.com"
		},
		{
			"id": "miles",
			"title": "Miles",
			"description": "Portfolio for the creative & independent Paris based production company Miles. <br> <small>Design by <a href=\"http://kevinlagier.com/\" target=\"_blank\">Kevin Lagier</a></small> ",
			"live": true,
			"url": "https://miles.tv"
		},
		{
			"id": "obachan",
			"title": "obachan",
			"description": "Minimalist webshop build on Shopify for the best traditional Japanese products handpicked by <a href=\"http://eien.tokyo/\" target=\"_blank\">Michele Angeloro</a><br> <small>Design by <a href=\"http://eien.tokyo/\" target=\"_blank\">Michele Angeloro</a></small> ",
			"extra": "Awwwards - Site of the Day 28/02/2019 <br> Awwwards - Developer Award & Mobile Excellence 07/02/2019",
			"live": true,
			"url": "https://getobachan.com"
		},
		{
			"id": "jason",
			"title": "Jason&nbsp;Yan&nbsp;Francis",
			"description": "Jason is a young and talented director, with a flashy new portfolio. <br> <small>Design by Jason</small> ",
			"extra": "CSSDSGN - 16/01/2018 <br> French Design Index - Site of the day 04/03/2018",
			"live": false
		},
		{
			"id": "protest",
			"title": "Protest",
			"description": "Multilingual e-commerce and brand website for the sportswear brand.<br> <small>Built at <a href=\"http://buildinamsterdam.com\" target=\"_blank\">Build in Amsterdam</a></small>",
			"extra": "Awwwards - Site of the year - E-commerce 2016<br> Awwwards - Site of the day 08/12/2016 <br> CSSDA - Website of the day 10/12/2016",
			"live": true,
			"url": "http://protest.eu"
		},
		{
			"id": "etqstore",
			"title": "ETQ&nbsp;Store",
			"description": "Online multibrand store for the Amsterdam flagship store of ETQ <br> <small>Built at <a href=\"http://buildinamsterdam.com\" target=\"_blank\">Build in Amsterdam</a></small>",
			"extra": "Siteinspire",
			"live": true,
			"url": "https://www.etqstore.com/"
		}
	],
	"archives": [
		{
			"id": "lechemiseur",
			"title": "Le Chemiseur",
			"description": "New version of the shirt configurator app inside the webshop, allowing you to generate and modify all your measurements before ordering. <br> <small>UI and Development for <a href=\"https://athom.co/\" target=\"_blank\">Athom</a></small>",
			"live": true,
			"url": "https://lechemiseur.fr/"
		},
		{
			"id": "ag2r-triss",
			"title": "AG2R Trophées Régionaux des Initiatives Sociales et Solidaires",
			"description": "Application form and showcase for a Social and Solidarity Economy grant <br> <small>UX, UI and Development for <a href=\"https://athom.co/\" target=\"_blank\">Athom</a></small>",
			"live": true,
			"url": "https://www.initiative-sociale.ag2rlamondiale.fr/"
		},
		{
			"id": "desperados",
			"title": "Desperados FuturEdition",
			"description": "Promotion website for Desperados limited edition bottle on which the label is the gateway to an artistic experience mixing AR and VR<br> <small>Built at <a href=\"https://www.mnstr.com/en/\" target=\"_blank\">MNSTR</a></small>",
			"extra": "",
			"live": false
		},
		{
			"id": "cantorfineart",
			"title": "Cantor&nbsp;Fine&nbsp;Art",
			"description": "Los Angeles based art gallery e-commerce <br> <small>Built at <a href=\"http://buildinamsterdam.com\" target=\"_blank\">Build in Amsterdam</a></small>",
			"live": false,
			"extra": "Awwwards - Site of the day 31/05/2016 <br> CSSDA - Website of the day 02/06/2016"
		},
		{
			"id": "cultcheers",
			"title": "Cultcheers",
			"description": "Colorful landing page for this startup launching a new concept of informal cultural meetups at home. <br> <small>Built for <a href=\"https://pantographe.studio/en\">Pantographe</a>, design by <a href=\"https://www.behance.net/marinesergent\" target=\"_blank\">Marine Sergent</a> </small>",
			"live": false
		},
		{
			"id": "upcraft",
			"title": "Upcraft",
			"description": "Upcraft is an innovative upcycling brand that transforms high quality surplus materials from diverse industries into stylish design accessories. <br> <small>Design by <a href=\"https://www.michaelspeichert.com\" target=\"_blank\">Michael Speichert</a> </small>",
			"extra": "Mindsparkle",
			"live": true,
			"url": "http://upcraft.de"
		},
		{
			"id": "amsterdamevenements",
			"title": "Amsterdam Évènements",
			"description": "Multilingual showcase site for the Amsterdam based event planning company. <br> <small>Design by <a href=\"https://www.behance.net/marinesergent\" target=\"_blank\">Marine Sergent</a> </small>",
			"live": true,
			"url": "http://www.amsterdamevenements.com"
		},
		{
			"id": "newfysic",
			"title": "Newfysic",
			"description": "Dashboard application and brand/e-commerce website for the slimming method clients. <br> <small>Built at <a href=\"http://buildinamsterdam.com\" target=\"_blank\">Build in Amsterdam</a></small>",
			"extra": "",
			"live": false
		},
		{
			"title": "Michel Weidmann",
			"description": "Portfolio for my father who's working as sculptor for the entertainment industry. <br> <small>Personnal project</small>",
			"live": true,
			"url": "http://michelweidmann.fr/"
		},
		{
			"id": "cloudfaves",
			"title": "Cloudfaves",
			"description": "Enhanced soundcloud player. <br> <small>Personnal project</small>",
			"live": false
		},
		{
			"id": "sparked",
			"title": "Sparked",
			"description": "Responsive business to business platform. <br> <small>Built at <a href=\"http://buildinamsterdam.com\" target=\"_blank\">Build in Amsterdam</a></small>",
			"extra": "Awwwards - Site of the day 13/05/2016 <br> Awwwards - Developer site of the day 13/05/2016 <br> CSSDA - Website of the day 03/04/2016",
			"live": false,
			"no_details": true
		},
		{
			"id": "high45",
			"title": "HIGH45",
			"description": "High intensity interval training boutique based in Amsterdam. <br> <small>Built at <a href=\"http://buildinamsterdam.com\" target=\"_blank\">Build in Amsterdam</a></small>",
			"live": true,
			"url": "http://high45.com",
			"extra": ""
		},
		{
			"id": "kibi",
			"title": "Kibi",
			"description": "Social application dedicated to happiness instants. <br> <small>Final year project made at <a href=\"http://gobelins.fr\" target=\"_blank\">Gobelins</a> <br> with <a href=\"https://www.linkedin.com/pub/alexandre-pav%C3%A9-martinot/35/852/207\" target=\"_blank\">Alexandre Pavé-Martinot</a>, <a href=\"https://www.linkedin.com/pub/olivia-friedrich/61/217/141\" target=\"_blank\">Olivia Friedrich</a> and <a href=\"http://damienseguin.me/\" target=\"_blank\">Damien Seguin</a> </small>",
			"live": false
		},
		{
			"id": "pabloscope",
			"title": "Pabloscope",
			"description": "Mobile app for the reopening of the Picasso Museum in Paris. <br> <small>made at <a href=\"http://gobelins.fr\" target=\"_blank\">Gobelins</a> with <a href=\"http://louisansa.com/\" target=\"_blank\">Louis Ansa</a>, <a href=\"http://alexiadupredoan.free.fr/\" target=\"_blank\">Alexia Dupré-Doàn</a> and <a href=\"https://www.behance.net/crys9\" target=\"_blank\">Christophe Massolin</a></small>",
			"live": false
		},
		{
			"id": "plug",
			"title": "PLUG",
			"description": "Collaborative musical installation designed for families visiting <a href=\"http://lecube.com/\" target=\"_blank\">Le Cube</a>. <br> <small>First year project made at <a href=\"http://gobelins.fr\" target=\"_blank\">Gobelins</a> with <a href=\"http://artsime.com/\" target=\"_blank\">Siméon Artamonov</a></small>",
			"live": false
		},
		{
			"id": "citroen",
			"title": "Citröen C-Elysée",
			"description": "Front-end development. <br> <small>made at <a href=\"http://bigyouth.fr\" target=\"_blank\">Big Youth</a> in collaboration with <a href=\"https://fr.linkedin.com/in/yannick-eustache-99547050\" target=\"_blank\">Yannick Eustache</a></small>",
			"live": false,
			"no_details": true
		},
		{
			"title": "Ferrari",
			"description": "Front development of media modules. <br> <small>made at <a href=\"http://bigyouth.fr\" target=\"_blank\">Big Youth</a></small>",
			"live": false,
			"no_details": true
		}
	],
	"experience": [
		{
			"date": "12/16 — now",
			"description": "Freelance front-end developer",
			"location": "Paris"
		},
		{
			"date": "11/14 — 11/16",
			"description": "Front-end developer<br> at <a href=\"http://buildinamsterdam.com\" target=\"_blank\">Build in Amsterdam</a>",
			"location": "Amsterdam"
		},
		{
			"date": "09/12 — 08/14",
			"description": "Apprentice web developer<br> at <a href=\"http://bigyouth.fr\" target=\"_blank\">Big Youth</a>",
			"location": "Paris"
		}
	],
	"education": [
		{
			"date": "09/12&nbsp;-&nbsp;06/14",
			"title": "Gobelins, CRMA",
			"description": "Multimedia design and production"
		},
		{
			"date": "09/11&nbsp;-&nbsp;06/12",
			"title": "Paris 13, LP CIWM",
			"description": ""
		},
		{
			"date": "09/09&nbsp;-&nbsp;06/11",
			"title": "IUT Champs, DUT SRC",
			"description": ""
		}
	],
	"about": "After 2 years abroad working for <a href=\"http://buildinamsterdam.com\" target=\"_blank\">Build in Amsterdam</a>, I’m now back in Paris and available for freelance work as Front-end developer.<br> Before this, I had the chance to work at <a href=\"http://bigyouth.fr\" target=\"_blank\">Big Youth</a> in apprenticeship while studying at <a href=\"http://gobelins.fr\" target=\"_blank\">Gobelins</a> in Paris.",
	"links": [
		{
			"url": "mailto:kolin.w@gmail.com",
			"label": "kolin.w@gmail.com"
		},
		{
			"url": "http://twitter.com/kolin_w",
			"label": "Twitter"
		},
		{
			"url": "https://www.linkedin.com/in/kolin-weidmann-77963664/",
			"label": "LinkedIn"
		},
		{
			"url": "http://instagram.com/kolin_w",
			"label": "Instagram"
		}
	],
	"modals": {
		"jason": {
			"id": "jason",
			"title": "Jason Yan Francis",
			"sections": [
				{
					"type": "video",
					"url": "jasonyanfrancis.mp4"
				}
			]
		},
		"desperados": {
			"id": "desperados",
			"title": "Desperados FuturEdition",
			"sections": [
				{
					"type": "video",
					"url": "futuredition.mp4"
				}
			]
		},
		"cantorfineart": {
			"id": "cantorfineart",
			"title": "Cantor Fine Arts",
			"sections": [
				{
					"type": "image",
					"url": "screen1.jpg"
				}
			]
		},
		"cultcheers": {
			"id": "cultcheers",
			"title": "Cultcheers",
			"description": "Colorful landing page for this startup launching a new concept of informal cultural meetups at home.",
			"sections": [
				{
					"type": "image",
					"url": "screen1.jpg",
					"caption": ""
				},
				{
					"type": "video",
					"url": "loop1.mp4",
					"caption": "Smooth scroll and canvas text masked animations"
				}
			]
		},
		"newfysic": {
			"id": "newfysic",
			"title": "NewFysic",
			"description": "Dashboard application and brand/e-commerce website for the slimming method clients. ",
			"sections": [
				{
					"type": "text",
					"content": "<p>Clients of the slimming method get access to an online tool to track their improvements and manage their treatment on a day to day basis.</p>"
				},
				{
					"type": "image",
					"url": "screen1.jpg",
					"caption": "The body measurement dashboard gives them a quickview of their achievement and the goal to reach."
				},
				{
					"type": "image",
					"url": "screen2.jpg",
					"caption": "Their personal diet calendar mixes their appointments with the coach, their food planning, and activities related to the slimming process."
				},
				{
					"type": "image",
					"url": "screen4.jpg",
					"caption": "Recipes can be added directly to the calendar and to their groceries list. It gives them a visibility of what is needed per recipe or overall."
				},
				{
					"type": "image",
					"url": "screen3.jpg",
					"caption": "A logbook if offered to share their journey during the program."
				},
				{
					"type": "image",
					"url": "screen5.jpg",
					"caption": "Quick re-order enables a faster shopping experience."
				}
			]
		},
		"kibi": {
			"id": "kibi",
			"title": "Kibi",
			"description": "Social application dedicated to happiness instants.",
			"sections": [
				{
					"type": "image",
					"url": "1_gif_intro.gif"
				},
				{
					"type": "text",
					"content": "<p>Share these moments with everyone around and allow them to join you. Build stop-motion of these moments by adding your 'kibi' on another one.<br> Make it fun !</p>"
				},
				{
					"type": "video",
					"poster": "2_teaser_cover.jpg",
					"urls": {
						"mp4": "2_teaser.mp4",
						"webm": "2_teaser.webm"
					},
					"caption": "Teaser"
				},
				{
					"type": "text",
					"content": "<p>The app was designed for an iPhone 5 running iOS 7.<br> It was built using Storyboard for the user journey, Cocoapods to manage dependencies like WhirlyGlobe for the main globe navigation, Mapbox for the local map, GPUImage for image capture and manipulation, Parse SDK for the backend communication. Parse is also our media storage and push notifications.</p>"
				},
				{
					"type": "video",
					"poster": "5_screen_cover.jpg",
					"vertical": true,
					"urls": {
						"mp4": "5_screen.mp4",
						"webm": "5_screen.webm"
					},
					"caption": "Screencap of the iOs app"
				},
				{
					"type": "video",
					"poster": "4_rendu_cover.jpg",
					"urls": {
						"mp4": "4_rendu.mp4",
						"webm": "4_rendu.webm"
					},
					"caption": "Examples of kibis"
				},
				{
					"type": "video",
					"poster": "6_makingof_cover.jpg",
					"urls": {
						"mp4": "6_makingof.mp4",
						"webm": "6_makingof.webm"
					},
					"caption": "Making of the teaser"
				},
				{
					"type": "text",
					"content": "<p><a href=\"/static/kibi/kibi_en.pdf\" target=\"_blank\">Read the presentation</a><sup>PDF</sup> we made</p>"
				}
			]
		},
		"pabloscope": {
			"id": "pabloscope",
			"title": "Pabloscope",
			"description": "iOS 7 native application for the reopening of the Picasso Museum in Paris.",
			"sections": [
				{
					"type": "image",
					"url": "0_intro.jpg",
					"caption": "After 5 years closed for renovation, the museum asked for a promotional application for its reopening. We had 3 months to find our idea and produce it.<br> Our response \"Pabloscope\" won the picasso jury approval."
				},
				{
					"type": "embed",
					"content": "<iframe src=\"https://player.vimeo.com/video/104795610\" width=\"640\" height=\"360\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>"
				},
				{
					"type": "image",
					"url": "2_inspi.jpg"
				},
				{
					"type": "image",
					"url": "3_end.jpg"
				},
				{
					"type": "text",
					"content": "<p><a href=\"/static/pabloscope/picasso_en.pdf\" target=\"_blank\">Read the presentation</a><sup>PDF</sup> we made</p>"
				}
			]
		},
		"plug": {
			"id": "plug",
			"title": "Plug",
			"description": "Collaborative musical experience designed for families visiting Le Cube.",
			"sections": [
				{
					"type": "image",
					"url": "1_intro.jpg",
					"caption": "With their smartphones, visitors can interact with a \"totem\". Up to 4 of them can connect to the web-app and play music together. They will hear and see their place in the orchestra through the totem."
				},
				{
					"type": "embed",
					"content": "<iframe src=\"https://player.vimeo.com/video/69433394\" width=\"640\" height=\"360\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>"
				},
				{
					"type": "image",
					"url": "3_slide_1.jpg"
				},
				{
					"type": "image",
					"url": "3_slide_2.jpg"
				},
				{
					"type": "image",
					"url": "3_slide_3.jpg"
				},
				{
					"type": "image",
					"url": "3_slide_4.jpg"
				},
				{
					"type": "text",
					"content": "<p>To play with PLUG, visitors have to connect their smartphones to our wifi and visit our webpage. They will get the webapp, which communicates to our Node server through websockets. This server then transmit messages to Max MSP through the OSC protocol. Max MSP will receive all visitor's actions and play audio accordingly. In the same time it will direct the arduino to light up the totem in accordance with the sound it produces.</p>"
				},
				{
					"type": "video",
					"url": "3_makingof.mp4",
					"caption": "Demo of the Arduino controlling the led strip"
				},
				{
					"type": "image",
					"url": "4_slide_3.jpg",
					"caption": "Dashboard of the Max MSP patch"
				},
				{
					"type": "image",
					"url": "4_slide_1.jpg"
				},
				{
					"type": "image",
					"url": "4_slide_2.jpg",
					"caption": "Mock-ups of the web-app"
				},
				{
					"type": "text",
					"content": "<p>Exhibition: <br> Le Cube, 22/06/13<br> Happy Cube Day, 21/09/13<br> DIY Days, ESCP Europe Paris, 22/03/14</p>"
				}
			]
		},
		"cloudfaves": {
			"id": "cloudfaves",
			"title": "Cloudfaves",
			"description": "Enhanced soundcloud player.",
			"sections": [
				{
					"type": "image",
					"url": "1_slide.jpg"
				},
				{
					"type": "text",
					"content": "<p>Soundcloud webapp demo with useful added features such as: one page only, no infinite scroll, favorites search, manageable queue. <br> Personal project driven by my needs as a heavy user of Soundcloud. It was a chance to play with their API, and test Backbone Marionette's framework.</p>"
				},
				{
					"type": "image",
					"url": "2_slide.jpg"
				},
				{
					"type": "text",
					"content": "<p><a href=\"http://sound.kolin.fr/beta/\" target=\"_blank\">Try the demo here</a><sup>↙</sup></p>"
				}
			]
		}
	}
};

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_scroll__ = __webpack_require__(72);








var DefaultScroll = function (_Scroll) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(DefaultScroll, _Scroll);

  function DefaultScroll() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DefaultScroll);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DefaultScroll.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(DefaultScroll)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DefaultScroll, [{
    key: 'extendCache',
    value: function extendCache(cache) {

      cache.isVisible = true;
      return cache;
    }
  }, {
    key: 'cacheBoundings',
    value: function cacheBoundings() {

      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(DefaultScroll.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(DefaultScroll.prototype), 'cacheBoundings', this).call(this);

      this.options.container.style.height = this.options.inner.getBoundingClientRect().height + 'px';
    }
  }, {
    key: 'prepareElements',
    value: function prepareElements() {

      for (var index = 0; index < this.vars.triggersCache.length; index++) {
        var cache = this.vars.triggersCache[index];
        if (!cache) return false;

        this.prepareElement(cache);
      }
    }
  }, {
    key: 'prepareElement',
    value: function prepareElement(cache) {

      var position = this.getPosition(cache);

      if (!position.isVisible) {
        cache.el.classList.remove('in-view');
      }
    }
  }, {
    key: 'onScroll',
    value: function onScroll(e) {

      if (typeof this.vars.triggersCache === 'undefined') return;

      if (this.state.paused) return;

      for (var index = 0; index < this.vars.triggersCache.length; index++) {
        this.inView(index);
      }
    }
  }, {
    key: 'getPosition',
    value: function getPosition(cache) {

      var top = Math.round(cache.top - this.vars.current.scrollY);
      var bottom = Math.round(cache.bottom - this.vars.current.scrollY);

      var isAbove = bottom < 0 - this.options.padding.bottom;
      var isBelow = top > this.vars.windowInnerHeight + this.options.padding.top;

      return {
        top: top,
        bottom: bottom,
        isAbove: isAbove,
        isBelow: isBelow,
        isVisible: top < this.vars.windowInnerHeight + this.options.padding.bottom && bottom > 0 - this.options.padding.top
      };
    }
  }, {
    key: 'inView',
    value: function inView(index) {

      if (!this.vars.triggersCache) return false;

      var cache = this.vars.triggersCache[index];
      if (!cache) return false;

      if (cache.options.header) {
        if (this.vars.current.scrollY !== 0) {
          cache.el.classList.add('has-scrolled');
          cache.options.header = false;
        }
      }

      var position = this.getPosition(cache);

      if (position.isVisible) {
        cache.el.classList.add('in-view');
      } else {
        cache.el.classList.remove('in-view');
      }
    }
  }, {
    key: 'virtualScroll',
    value: function virtualScroll() {

      if (this.trim(this.vars.current.scrollY) !== this.options.targetY) {
        this.options.targetY = this.options.targetY + Math.ceil(this.options.lerp * (this.vars.current.scrollY - this.options.targetY));
        this.options.targetY = this.trim(this.options.targetY);

        this.options.inner.style[this.options.transformProperty] = this.getTransform(this.options.targetY);
      }
    }
  }, {
    key: 'update',
    value: function update() {

      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(DefaultScroll.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(DefaultScroll.prototype), 'update', this).call(this);

      this.options.virtualScroll && this.virtualScroll();
    }
  }, {
    key: 'getTransform',
    value: function getTransform(value) {
      return 'translate3d(0,' + -value + 'px,0)';
    }
  }, {
    key: 'trim',
    value: function trim(value) {
      return parseInt(value, 10);
    }
  }]);

  return DefaultScroll;
}(__WEBPACK_IMPORTED_MODULE_6__lib_scroll__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({

  methods: {
    initScroll: function initScroll(scrollableEl) {
      if (!this.store.scrollFx) return true;

      var triggers = this.$el.querySelectorAll('.on-scroll');
      this.scroll = new DefaultScroll({
        lerp: 0.2,
        scrollEl: typeof scrollableEl !== 'undefined' ? scrollableEl : false,
        virtualScroll: this.store.virtualScroll,
        container: this.$refs.container,
        inner: this.$refs.inner,
        targetY: 0,
        triggers: triggers,
        padding: {
          top: 100,
          bottom: -75 },
        delegate: this
      });
    }
  }

});

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({

  isLarge: true,
  isRetina: false,
  scrollFx: true,
  virtualScroll: true,
  showModal: false,
  currentRoute: window.location.pathname

});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_admin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_admin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_base64__ = __webpack_require__(38);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/*',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_home___default.a
  }, {
    path: '/' + __WEBPACK_IMPORTED_MODULE_4__lib_base64__["a" /* default */].encode(Date.now()),
    name: 'admin',
    component: __WEBPACK_IMPORTED_MODULE_3__components_admin___default.a
  }]
}));

/***/ }),
/* 60 */,
/* 61 */
/***/ (function(module, exports) {

;(function(window){
var hadGlobal = 'Modernizr' in window;
var oldGlobal = window.Modernizr;
/*! modernizr 3.5.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-touchevents-setclasses !*/
!function(e,n,t){function o(e,n){return typeof e===n}function s(){var e,n,t,s,a,i,r;for(var l in f)if(f.hasOwnProperty(l)){if(e=[],n=f[l],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(s=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],r=i.split("."),1===r.length?Modernizr[r[0]]=s:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=s),d.push((s?"":"no-")+r.join("-"))}}function a(e){var n=u.className,t=Modernizr._config.classPrefix||"";if(p&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(o,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(n+=" "+t+e.join(" "+t),p?u.className.baseVal=n:u.className=n)}function i(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):p?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}function r(){var e=n.body;return e||(e=i(p?"svg":"body"),e.fake=!0),e}function l(e,t,o,s){var a,l,f,c,d="modernizr",p=i("div"),h=r();if(parseInt(o,10))for(;o--;)f=i("div"),f.id=s?s[o]:d+(o+1),p.appendChild(f);return a=i("style"),a.type="text/css",a.id="s"+d,(h.fake?h:p).appendChild(a),h.appendChild(p),a.styleSheet?a.styleSheet.cssText=e:a.appendChild(n.createTextNode(e)),p.id=d,h.fake&&(h.style.background="",h.style.overflow="hidden",c=u.style.overflow,u.style.overflow="hidden",u.appendChild(h)),l=t(p,e),h.fake?(h.parentNode.removeChild(h),u.style.overflow=c,u.offsetHeight):p.parentNode.removeChild(p),!!l}var f=[],c={_version:"3.5.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){f.push({name:e,fn:n,options:t})},addAsyncTest:function(e){f.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=c,Modernizr=new Modernizr;var d=[],u=n.documentElement,p="svg"===u.nodeName.toLowerCase(),h=c._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];c._prefixes=h;var m=c.testStyles=l;Modernizr.addTest("touchevents",function(){var t;if("ontouchstart"in e||e.DocumentTouch&&n instanceof DocumentTouch)t=!0;else{var o=["@media (",h.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");m(o,function(e){t=9===e.offsetTop})}return t}),s(),a(d),delete c.addTest,delete c.addAsyncTest;for(var v=0;v<Modernizr._q.length;v++)Modernizr._q[v]();e.Modernizr=Modernizr}(window,document);
module.exports = window.Modernizr;
if (hadGlobal) { window.Modernizr = oldGlobal; }
else { delete window.Modernizr; }
})(window);

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(128)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(157),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */,
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_json_editor__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_json_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_json_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schema_json__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schema_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__schema_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_data_json__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_data_json__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'admin',
  props: [],
  data: function data() {
    return {};
  },
  mounted: function mounted() {

    this.editor = new JSONEditor(this.$refs.editor, {
      schema: __WEBPACK_IMPORTED_MODULE_1__schema_json___default.a,
      theme: "bootstrap3",
      disable_edit_json: true,
      disable_collapse: true,
      disable_properties: true
    });

    this.editor.setValue(__WEBPACK_IMPORTED_MODULE_2__assets_data_json___default.a);
  },

  methods: {
    _onClickDump: function _onClickDump() {
      window.dump = this.editor.getValue();
      console.info('now run \'copy(dump)\'');
    }
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_notification_center__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__project_experiment__ = __webpack_require__(67);





var SCALE_MIN = 0;
var SCALE_MAX = 100;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'experiment',
  props: [],
  data: function data() {
    return {};
  },

  computed: {},
  mounted: function mounted() {
    var _this = this;

    this._getBounds();

    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].nextTick(function () {
      PIXI.loader.add('/static/texture.json').load(function () {
        var texture = new PIXI.Texture.fromFrame('jason.png');
        _this.renderer.bindTexture(texture);
      });
      _this._initCanvas();
      _this._resizeCanvas();
    });

    __WEBPACK_IMPORTED_MODULE_1__lib_notification_center__["a" /* default */].on('project:hover', this.toggleProject);
    __WEBPACK_IMPORTED_MODULE_1__lib_notification_center__["a" /* default */].on('scroll', function () {
      _this.toggleProject({ show: false });
    });

    this.currentProjects = [];
  },


  methods: {
    _initCanvas: function _initCanvas() {

      this.tick = 1;

      this.renderer = PIXI.autoDetectRenderer(256, 256, {
        resolution: window.devicePixelRatio,
        transparent: true
      });
      this.$refs.renderer.appendChild(this.renderer.view);

      this.stage = new PIXI.Container();
      this.stage.interactive = false;

      this.backgroundGraphic = new PIXI.Graphics();
      this.backgroundGraphic.beginFill(0xFFFFFF, 0.8);
      this.backgroundGraphic.drawRect(0, 0, this.bounds.width, this.bounds.height);
      this.backgroundGraphic.alpha = 0;
      this.stage.addChild(this.backgroundGraphic);

      this.displacementTexture = PIXI.Texture.fromImage('/static/displacementmap.jpg');
      this.displacementSprite = new PIXI.Sprite(this.displacementTexture);
      this.displacementSprite.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT;
      this.displacementFilter = new PIXI.filters.DisplacementFilter(this.displacementSprite);
      this.displacementFilter.resolution = window.devicePixelRatio;
      this.displacementFilter.scale = { x: SCALE_MIN, y: SCALE_MIN };

      PIXI.ticker.shared.add(this._loop, this);
    },
    _loop: function _loop() {
      if (!this.dirty) return false;

      this.tick += 0.01;

      this.renderer.render(this.stage);
      this.dirty = false;
    },
    _getBounds: function _getBounds() {
      this.bounds = this.$el.getBoundingClientRect();
    },
    _resizeCanvas: function _resizeCanvas() {
      if (this.renderer) {
        this.renderer.resize(this.bounds.width, this.bounds.height);
        this.dirty = true;
      }
    },
    _onResize: function _onResize() {
      this._getBounds();
      this._resizeCanvas();
    },
    toggleProject: function toggleProject(params) {

      if (params.show) {
        this.showProject(params);
      } else {
        this.closeProject(params);
      }
    },
    showProject: function showProject(params) {

      var projectExperiment = new __WEBPACK_IMPORTED_MODULE_2__project_experiment__["a" /* default */]({
        parent: this,
        project: params.project
      });
      projectExperiment.animateIn();
      this.currentProjects[params.project.id] = projectExperiment;
    },
    closeProject: function closeProject(params) {

      if (typeof params.project !== 'undefined') {
        var projectExperiment = this.currentProjects[params.project.id];
        projectExperiment.animateOut();
      }
    }
  }
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap__);




var SCALE_MIN = 0;
var SCALE_MAX = 100;

var ProjectExperiment = function () {
  function ProjectExperiment(opts) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ProjectExperiment);

    this.parent = opts.parent;
    this.project = opts.project;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ProjectExperiment, [{
    key: 'animateIn',
    value: function animateIn() {

      if (this.animatingOut) {
        this.animationOut.pause();
      }

      this.animatingIn = true;

      this.projectTexture = PIXI.Texture.fromFrame(this.project.id + '.png');

      this.projectContainer = new PIXI.Graphics();
      this.projectContainer.fillAlpha = 0;
      this.projectContainer.drawRect(0, 0, this.projectTexture.width * .5 + 200, this.projectTexture.height * .5 + 200);
      this.projectContainer.pivot = { x: (this.projectTexture.width * .5 + 200) * .5, y: (this.projectTexture.height * .5 + 200) * .5 };

      this.projectContainer.position = { x: this.parent.bounds.width / 2, y: this.parent.bounds.height / 2 };
      this.projectContainer.scale = { x: 1.15, y: 1.15 };
      this.projectContainer.filters = [this.parent.displacementFilter];

      this.projectSprite = new PIXI.Sprite(this.projectTexture);
      this.projectSprite.position = { x: 100, y: 100 };
      this.projectSprite.width = this.projectTexture.width * .5;
      this.projectSprite.height = this.projectTexture.height * .5;

      var border = new PIXI.Graphics();
      border.lineStyle(1, 0xf2f2f2);
      border.drawRect(this.projectSprite.x, this.projectSprite.y, this.projectSprite.width, this.projectSprite.height);

      this.projectContainer.addChild(this.projectSprite);
      this.projectContainer.addChild(border);
      this.parent.stage.addChild(this.projectContainer);

      this.animationIn = new __WEBPACK_IMPORTED_MODULE_2_gsap__["TimelineLite"]({
        paused: true,
        onUpdateScope: this,
        onUpdate: function onUpdate() {
          this.parent.dirty = true;
        },
        onCompleteScope: this,
        onComplete: function onComplete() {
          this.parent.dirty = true;
          this.animatingIn = false;
        }
      });

      this.animationIn.from(this.projectContainer, 2, {
        alpha: 0,
        rotation: (-.1 + Math.random() * .2) * Math.PI,
        ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Expo"].easeOut
      });

      this.animationIn.to(this.projectContainer.scale, 1.5, {
        x: 1,
        y: 1,
        ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Expo"].easeOut
      }, 0);

      this.animationIn.to(this.parent.backgroundGraphic, 1.5, {
        alpha: 1,
        ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Expo"].easeOut
      }, 0);

      this.animationIn.fromTo(this.parent.displacementFilter.scale, 2, {
        x: SCALE_MAX,
        y: SCALE_MAX
      }, {
        x: SCALE_MIN,
        y: SCALE_MIN,
        ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Expo"].easeOut
      }, 0.1);

      this.animationIn.play();
    }
  }, {
    key: 'animateOut',
    value: function animateOut(callback) {

      if (this.animatingIn) {
        this.animationIn.pause();
      }

      this.animatingOut = true;

      this.animationOut = new __WEBPACK_IMPORTED_MODULE_2_gsap__["TimelineLite"]({
        paused: true,
        onUpdateScope: this,
        onUpdate: function onUpdate() {
          this.parent.dirty = true;
        },
        onCompleteScope: this,
        onComplete: function onComplete() {
          this.projectSprite.destroy();
          this.projectContainer.destroy();
          this.parent.displacementFilter.scale = { x: 0, y: 0 };

          this.parent.dirty = true;
          this.animatingOut = false;
          if (typeof callback === 'function') callback();
        }
      });

      this.animationOut.fromTo(this.parent.displacementFilter.scale, .3, {
        x: SCALE_MIN,
        y: SCALE_MIN
      }, {
        x: SCALE_MAX,
        y: SCALE_MAX,
        ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Expo"].easeOut
      });

      this.animationOut.to(this.projectContainer, .3, {
        alpha: 0
      }, 0);

      this.animationOut.to(this.parent.backgroundGraphic, .3, {
        alpha: 0,
        ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Expo"].easeOut
      }, 0);

      this.animationOut.play();
    }
  }]);

  return ProjectExperiment;
}();

/* harmony default export */ __webpack_exports__["a"] = (ProjectExperiment);

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_notification_center__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_project__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_project___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_project__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_experiment__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_experiment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_experiment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_default_scroll__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_svg_logo_svg__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_svg_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_svg_logo_svg__);














/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_default_scroll__["a" /* default */]],
  props: [],
  data: function data() {
    return {
      logo: '',
      updateKey: 0
    };
  },


  components: {
    project: __WEBPACK_IMPORTED_MODULE_2__components_project___default.a,
    modal: __WEBPACK_IMPORTED_MODULE_3__components_modal___default.a,
    experiment: __WEBPACK_IMPORTED_MODULE_4__components_experiment___default.a
  },

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].nextTick(this._nextTick.bind(this));

    __WEBPACK_IMPORTED_MODULE_1__lib_notification_center__["a" /* default */].on('modal:opened', this._onModalOpened);
    __WEBPACK_IMPORTED_MODULE_1__lib_notification_center__["a" /* default */].on('modal:closed', this._onModalClosed);

    this.$data.logo = __WEBPACK_IMPORTED_MODULE_7__assets_svg_logo_svg___default.a;
  },


  methods: {
    _nextTick: function _nextTick() {
      var _this = this;

      setTimeout(function () {
        _this.initScroll();
      }, 300);

      var nowId = __WEBPACK_IMPORTED_MODULE_5__lib_utils__["a" /* default */].getStorageId();
      var lastStorage = __WEBPACK_IMPORTED_MODULE_5__lib_utils__["a" /* default */].getLastStorageId();
      if (lastStorage !== nowId) {
        localStorage.clear();
        this.updateKey = 1;
      }
    },
    _onModalOpened: function _onModalOpened() {
      typeof this.scroll !== 'undefined' && this.scroll.pause();
    },
    _onModalClosed: function _onModalClosed() {
      typeof this.scroll !== 'undefined' && this.scroll.play();
    }
  }
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_notification_center__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_default_scroll__ = __webpack_require__(40);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_default_scroll__["a" /* default */]],
  props: [],
  data: function data() {
    return {
      preloaded: false,
      project: false
    };
  },


  computed: {
    assetPath: function assetPath() {
      return '/static/' + this.project.id + '/';
    }
  },

  mounted: function mounted() {
    this.project = this.store.currentModal;

    this.preload(this._preloaded);

    __WEBPACK_IMPORTED_MODULE_3__lib_notification_center__["a" /* default */].emit('modal:opened');
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_3__lib_notification_center__["a" /* default */].emit('modal:closed');
    if (this.delayScrollId) clearTimeout(this.delayScrollId);
  },


  methods: {
    preload: function preload(callback) {
      var _this = this;

      var imagesUrl = __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.chain(this.project.sections).where({ 'type': 'image' }).pluck('url').map(function (img) {
        return _this.assetPath + img;
      }).value();

      if (imagesUrl.length) {
        __WEBPACK_IMPORTED_MODULE_2__lib_utils__["a" /* default */].loadImages(imagesUrl, callback);
      } else {
        callback();
      }
    },
    _preloaded: function _preloaded() {
      this.preloaded = true;

      this.delayScrollId = __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.delay(__WEBPACK_IMPORTED_MODULE_1_underscore___default.a.bind(function () {
        this.initScroll(this.$el);
        this.delayScrollId = false;
      }, this), 300);
    },
    _onClickClose: function _onClickClose() {
      this.store.showModal = false;
    }
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_button__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_notification_center__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils__ = __webpack_require__(19);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'project',
  props: {
    project: {
      type: Object
    },
    type: {
      type: String,
      default: 'project'
    }
  },
  data: function data() {
    return {
      visited: false
    };
  },

  computed: {
    isArchive: function isArchive() {
      return this.type == 'archive';
    }
  },
  mounted: function mounted() {

    this.visited = this.getVisited() ? true : false;
  },

  components: {
    'ui-button': __WEBPACK_IMPORTED_MODULE_1__components_ui_button___default.a
  },

  methods: {
    getVisited: function getVisited() {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].localStorage.get(this.$props.project.id);
    },
    setVisited: function setVisited(visited) {
      this.$data.visited = visited;
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].localStorage.set(this.$props.project.id, visited);
      __WEBPACK_IMPORTED_MODULE_3__lib_utils__["a" /* default */].setStorageIdNow();
    },
    wrapLetters: function wrapLetters() {
      if (!this.isArchive) {
        var txt = this.$refs.title.innerText;
        this.$refs.title.innerHTML = txt.replace(/./g, "<span>$&</span>");
      }
    },
    _onClickButton: function _onClickButton(e) {
      ga('set', 'page', this.project.title.toLowerCase());
      ga('send', 'pageview');
      this.setVisited(true);
      if (this.project.soon) {
        e.preventDefault();
        return false;
      }
      if (!this.project.live) {
        e.preventDefault();
        this.store.currentModal = this.db.modals[this.project.id];
        this.store.showModal = true;
      }
    },
    _onMouseEnter: function _onMouseEnter(e) {
      __WEBPACK_IMPORTED_MODULE_2__lib_notification_center__["a" /* default */].emit('project:hover', { show: true, project: this.$props.project, position: { x: e.clientX, y: e.clientY } });
    },
    _onMouseLeave: function _onMouseLeave(e) {
      __WEBPACK_IMPORTED_MODULE_2__lib_notification_center__["a" /* default */].emit('project:hover', { show: false, project: this.$props.project });
    }
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ui-button',
  props: ['project'],
  data: function data() {
    return {};
  },

  computed: {},
  mounted: function mounted() {},

  methods: {}
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_component_raf__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_component_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_component_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scrolltop__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scrolltop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_scrolltop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_events__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dom_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_get_prefix__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_get_prefix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_get_prefix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_object_assign__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_object_assign__);









var Scroll = function () {
    function Scroll() {
        var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Scroll);

        this.rid = Math.round(Math.random() * 10);

        this.options = {
            scrollEl: false,
            triggers: false,
            transformProperty: __WEBPACK_IMPORTED_MODULE_6_get_prefix___default()('transform')
        };

        var assign = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default.a || __WEBPACK_IMPORTED_MODULE_7_object_assign___default.a;

        this.options = assign(this.options, opt);

        this.vars = {
            windowInnerHeight: false,
            documentOffsetHeight: false,
            current: false
        };

        this.state = {
            paused: false
        };

        this.initialize();
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Scroll, [{
        key: 'initialize',
        value: function initialize() {

            this.rafId = false;

            this.bindAll();
            this.addEvents();

            this.run();

            this.cacheBoundings();

            this.scroll();

            this.prepareElements();
        }
    }, {
        key: 'bindAll',
        value: function bindAll() {
            var _this = this;

            var methods = ['onResize', 'cacheBoundings', 'run', 'scroll'];
            methods.forEach(function (fn) {
                return _this[fn] = _this[fn].bind(_this);
            });
        }
    }, {
        key: 'addEvents',
        value: function addEvents() {

            __WEBPACK_IMPORTED_MODULE_5_dom_events___default.a.on(window, 'resize', this.onResize);

            __WEBPACK_IMPORTED_MODULE_5_dom_events___default.a.on(this.options.scrollEl || window, 'scroll', this.scroll);
        }
    }, {
        key: 'cacheBoundings',
        value: function cacheBoundings() {

            this.vars.windowInnerHeight = window.innerHeight;
            this.vars.documentOffsetHeight = document.documentElement.offsetHeight;

            if (this.options.triggers) {
                this.cacheTriggersBoundings();
            }
        }
    }, {
        key: 'cacheTriggersBoundings',
        value: function cacheTriggersBoundings() {

            this.vars.triggersCache = [];

            for (var index = 0; index < this.options.triggers.length; index++) {

                var el = this.options.triggers[index],
                    scroll = this.vars.current.scrollY,
                    bounding = el.getBoundingClientRect();

                var optionsAttr = el.getAttribute('data-trigger'),
                    options = JSON.parse(optionsAttr);

                var bounds = {
                    el: el,
                    bounding: bounding,
                    parentNode: el.parentNode,
                    height: bounding.height,
                    half: bounding.height * .5,
                    top: bounding.top + scroll,
                    bottom: bounding.bottom + scroll,
                    options: options || false
                };

                bounds = this.extendCache(bounds);

                this.vars.triggersCache.push(bounds);
            }
        }
    }, {
        key: 'extendCache',
        value: function extendCache(bounds) {
            return bounds;
        }
    }, {
        key: 'prepareElements',
        value: function prepareElements() {}
    }, {
        key: 'run',
        value: function run() {

            this.rafId = __WEBPACK_IMPORTED_MODULE_3_component_raf___default()(this.run);

            this.update();
        }
    }, {
        key: 'update',
        value: function update() {

            if (this.options.scrollEl) {
                var scroll = this.options.scrollEl.scrollTop;
            } else {
                var scroll = __WEBPACK_IMPORTED_MODULE_4_scrolltop___default()();
            }

            var e = {
                scrollY: scroll,
                deltaY: scroll - this.vars.current.scrollY
            };
            this.vars.current = e;
        }
    }, {
        key: 'pause',
        value: function pause() {
            this.state.paused = true;
        }
    }, {
        key: 'play',
        value: function play() {
            this.state.paused = false;
        }
    }, {
        key: 'scroll',
        value: function scroll(e) {

            typeof this.onScroll === 'function' && this.onScroll(this.vars.current);
        }
    }, {
        key: 'onResize',
        value: function onResize() {

            this.cacheBoundings();
        }
    }, {
        key: 'destroy',
        value: function destroy() {

            __WEBPACK_IMPORTED_MODULE_3_component_raf___default.a.cancel(this.rafId);
            __WEBPACK_IMPORTED_MODULE_5_dom_events___default.a.off(window, 'resize', this.onResize);
            __WEBPACK_IMPORTED_MODULE_5_dom_events___default.a.off(window, 'scroll', this.scroll);
        }
    }]);

    return Scroll;
}();

/* harmony default export */ __webpack_exports__["a"] = (Scroll);

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modernizr__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modernizr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_modernizr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_is_retina__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_is_retina___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_is_retina__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_localstorage__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_notification_center__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_store__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_base64__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_data_json__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_data_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_data_json__);
















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin({
  data: function data() {
    return {
      store: __WEBPACK_IMPORTED_MODULE_7__lib_store__["a" /* default */],
      db: __WEBPACK_IMPORTED_MODULE_9__assets_data_json___default.a
    };
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_localstorage___default.a);

window.app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a },

  data: {
    key: false
  },

  watch: {
    key: function key(_key) {
      try {
        if (__WEBPACK_IMPORTED_MODULE_8__lib_base64__["a" /* default */].decode(_key) == 'admin') __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].push({ name: 'admin' });
      } catch (e) {
        console.error('wrong key');
      }
    }
  },

  mounted: function mounted() {
    window.scrollTop = 0;

    this._onResize();
    window.addEventListener('resize', this._onResize);
    window.addEventListener('scroll', this._onScroll);

    this._onChangeShowModal();
    this.$watch('store.showModal', this._onChangeShowModal);

    this.store.isRetina = __WEBPACK_IMPORTED_MODULE_2_is_retina___default()();
  },


  methods: {
    _onScroll: function _onScroll() {
      __WEBPACK_IMPORTED_MODULE_6__lib_notification_center__["a" /* default */].emit('scroll');
    },
    _onResize: function _onResize() {
      __WEBPACK_IMPORTED_MODULE_6__lib_notification_center__["a" /* default */].emit('resize', window.innerWidth, window.innerHeight);

      this.store.isLarge = window.innerWidth > 768;
      this.store.scrollFx = this.store.isLarge;
      this.store.virtualScroll = navigator.userAgent.indexOf('Chrome') > -1;
    },
    _onChangeShowModal: function _onChangeShowModal() {
      var action = this.store.showModal ? 'add' : 'remove';
      document.body.classList[action]('no-scroll');
    }
  }
});

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 120 120\"><path d=\"M43.41 84.96c-1.002 0-3.37-.56-7.985-4.303-1.085-.88-2.08-1.767-2.894-2.524.75-.445 1.483-1.038 2.198-1.777 1.417-1.464 2.728-3.464 3.897-5.944 2.11-4.475 3.473-10.012 3.473-14.107 0-1.795-.26-3.26-.777-4.354-.7-1.49-1.89-2.332-3.353-2.41-.026-.004-.052-.004-.078-.006-.05 0-.094-.01-.143-.01-.03 0-.057.007-.087.01-.03 0-.057-.004-.087 0-.036.002-.07.015-.104.02-.053.007-.104.016-.155.028-1.18.162-2.272.648-3.27 1.45.002-.19.02-.387.02-.577 0-5.04-.634-9.198-1.885-12.362-1.153-2.916-2.46-4.04-2.99-4.4l-.02-.013c-.04-.026-.084-.06-.114-.076-.027-.016-.056-.024-.083-.04-.058-.03-.116-.058-.176-.082-.054-.022-.108-.04-.163-.057-.056-.017-.112-.03-.17-.042-.058-.01-.116-.02-.176-.026-.058-.006-.115-.008-.173-.008-.06 0-.116.002-.174.008-.057.006-.115.015-.173.026s-.115.026-.172.043c-.054.016-.108.035-.16.057-.062.025-.12.053-.178.084-.027.015-.056.023-.082.04-1.617.98-3.545 3.41-3.545 9.402 0 7.18.563 18.25 1.148 27.807-3.23 5.805-6.082 7.797-6.923 7.797-1.005 0-1.82.815-1.82 1.82 0 1.005.815 1.82 1.82 1.82 2.645 0 5.286-2.625 7.31-5.333.48 7.28.887 12.62.897 12.748.073.952.868 1.68 1.813 1.68.03 0 .058 0 .088-.002.983-.047 1.75-.867 1.734-1.85 0-.06-.06-3.795.18-8.862.887.83 1.987 1.82 3.223 2.823 4.257 3.46 7.63 5.14 10.31 5.14 1.005 0 1.82-.815 1.82-1.82 0-1.003-.815-1.818-1.82-1.818zM29.207 59.595c-.178.593-.35 1.212-.514 1.858-.212.714-.44 1.425-.69 2.135-.41-7.53-.734-15.177-.734-20.58 0-2.366.353-4.003.827-5.036.967 1.683 2.327 5.313 2.327 12.48 0 2.902-.432 6.013-1.217 9.142zm1.03 15.628c.117-1.386.257-2.8.43-4.22.397-3.247.903-6.09 1.51-8.513.195-.655.38-1.31.546-1.966.232-.76.474-1.48.73-2.135.877-2.237 2.34-4.928 4.355-5.214.13.085.58.746.64 2.68.062 1.882-.27 4.33-.93 6.89-.885 3.42-2.28 6.728-3.83 9.075-1.153 1.748-2.344 2.91-3.452 3.404z\"/><path d=\"M62.402 59.075c1.617-4.02 2.487-8.778 2.487-13.8 0-4.852-.695-8.855-2.064-11.897-1.408-3.128-3.068-4.215-3.716-4.537-.02-.01-.043-.014-.064-.023-.06-.027-.12-.048-.182-.068-.054-.02-.107-.036-.16-.05-.06-.012-.118-.02-.178-.028-.058-.007-.116-.015-.174-.016-.058-.002-.116.002-.174.006-.06.004-.12.008-.18.018-.054.01-.107.023-.162.038-.063.017-.125.035-.187.058-.022.008-.045.01-.066.02-.04.018-.074.042-.113.06-.033.017-.067.033-.1.052-2.382 1.232-2.37 4.93-2.353 7.656l.002.54c0 3.86 1.562 12.963 3.558 21.627-.113.248-.22.504-.34.743-.428-1.118-.977-2.053-1.65-2.813-2.02-2.283-4.572-2.283-5.41-2.283-1.55 0-2.794 1.05-3.703 2.546-.08.088-.15.185-.212.29-.215.365-5.27 9.014-5.27 16.944 0 2.477.653 4.37 1.94 5.63 1.51 1.476 3.43 1.618 4.452 1.618.142 0 .267-.003.37-.005.06 0 .112-.003.156-.003 1.656 0 4.19-.702 6.338-2.674 1.265-1.16 2.26-2.634 2.953-4.378.79-1.987 1.192-4.336 1.192-6.984 0-.948-.032-1.843-.097-2.683.186-.246.366-.5.546-.762 1.26 4.888 2.59 9.22 3.756 11.8.304.673.966 1.072 1.66 1.072.25 0 .505-.052.748-.162.916-.414 1.323-1.492.91-2.408-1.255-2.773-2.92-8.397-4.512-15.142zM49.865 60.42c.498-1.52 1.133-2.26 1.384-2.402.887.007 1.813.152 2.612 1.054.605.684 1.293 1.988 1.648 4.466-1.577 1.724-3.3 2.724-4.817 2.724-.336 0-.96 0-1.246-1.44-.238-1.204-.078-2.89.418-4.402zm2.922 15.623c-1.848 1.696-3.794 1.715-3.876 1.715-.066 0-.145 0-.235.003-.588.014-1.57.036-2.197-.576-.552-.54-.844-1.587-.844-3.027 0-2.13.446-4.37 1.065-6.452.876 1.416 2.295 2.195 3.992 2.195 1.66 0 3.398-.598 5.044-1.733-.127 3.55-1.118 6.196-2.95 7.876zm5.873-38.938c0-.177 0-.365-.002-.56-.005-.936-.01-1.997.092-2.937l.015-.114c.237.365.49.818.742 1.378 1.44 3.2 1.743 7.424 1.743 10.404 0 2.14-.178 4.215-.508 6.19-1.287-6.41-2.082-11.83-2.082-14.36z\"/><path d=\"M73.8 72.653c-.222-.604-.776-2.7-1.23-9.316-.294-4.254-.398-8.246-.4-8.286-.025-1.004-.86-1.798-1.865-1.772-1.005.026-1.8.86-1.773 1.866 0 .048.128 4.867.49 9.623.217 2.827.475 5.092.767 6.733.19 1.066.394 1.88.627 2.49.628 1.644 1.63 1.99 2.36 1.99 1.006 0 1.82-.816 1.82-1.82 0-.628-.315-1.18-.796-1.507z\"/><path d=\"M69.52 42.64c1-.076 1.75-.95 1.674-1.953l-.08-1.052c-.078-1.002-.953-1.752-1.955-1.675-1.003.077-1.753.952-1.676 1.954l.08 1.052c.074.955.872 1.68 1.814 1.68.047 0 .094 0 .14-.005z\"/><path d=\"M92.713 63.696c-1.096-3.48-2.23-7.075-3.312-9.792-.613-1.537-1.168-2.688-1.697-3.517-.326-.51-1.317-2.063-2.952-2.063-2.064 0-3.052 2.498-3.816 4.84-.583 1.785-1.203 4.193-1.846 7.166l-.617-5.847c-.104-1-1-1.725-2-1.62-1 .106-1.725 1.002-1.62 2.002l1.943 18.406c.096.91.853 1.61 1.77 1.63h.04c.898 0 1.665-.656 1.8-1.547.007-.05.76-4.996 1.817-10.21 1.23-6.078 2.15-8.96 2.704-10.31.344.636.818 1.658 1.436 3.296.934 2.474 1.924 5.62 2.883 8.66 1.124 3.57 2.185 6.938 3.214 9.496.286.71.968 1.142 1.69 1.142.225 0 .455-.042.677-.132.933-.375 1.385-1.435 1.01-2.368-.978-2.43-2.067-5.888-3.12-9.232z\"/><path d=\"M102.146 72.433c-1.005 0-1.82.815-1.82 1.82v.08c0 1.006.815 1.82 1.82 1.82 1.005 0 1.82-.814 1.82-1.82v-.08c0-1.006-.815-1.82-1.82-1.82z\"/></svg>"

/***/ }),
/* 143 */,
/* 144 */,
/* 145 */
/***/ (function(module, exports) {

module.exports = {
	"initEvent": [
		"type",
		"bubbles",
		"cancelable"
	],
	"initUIEvent": [
		"type",
		"bubbles",
		"cancelable",
		"view",
		"detail"
	],
	"initMouseEvent": [
		"type",
		"bubbles",
		"cancelable",
		"view",
		"detail",
		"screenX",
		"screenY",
		"clientX",
		"clientY",
		"ctrlKey",
		"altKey",
		"shiftKey",
		"metaKey",
		"button",
		"relatedTarget"
	],
	"initMutationEvent": [
		"type",
		"bubbles",
		"cancelable",
		"relatedNode",
		"prevValue",
		"newValue",
		"attrName",
		"attrChange"
	],
	"initKeyboardEvent": [
		"type",
		"bubbles",
		"cancelable",
		"view",
		"ctrlKey",
		"altKey",
		"shiftKey",
		"metaKey",
		"keyCode",
		"charCode"
	],
	"initKeyEvent": [
		"type",
		"bubbles",
		"cancelable",
		"view",
		"ctrlKey",
		"altKey",
		"shiftKey",
		"metaKey",
		"keyCode",
		"charCode"
	]
};

/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports = {
	"MouseEvent": [
		"click",
		"mousedown",
		"mouseup",
		"mouseover",
		"mousemove",
		"mouseout"
	],
	"KeyboardEvent": [
		"keydown",
		"keyup",
		"keypress"
	],
	"MutationEvent": [
		"DOMSubtreeModified",
		"DOMNodeInserted",
		"DOMNodeRemoved",
		"DOMNodeRemovedFromDocument",
		"DOMNodeInsertedIntoDocument",
		"DOMAttrModified",
		"DOMCharacterDataModified"
	],
	"HTMLEvents": [
		"load",
		"unload",
		"abort",
		"error",
		"select",
		"change",
		"submit",
		"reset",
		"focus",
		"blur",
		"resize",
		"scroll"
	],
	"UIEvent": [
		"DOMFocusIn",
		"DOMFocusOut",
		"DOMActivate"
	]
};

/***/ }),
/* 147 */,
/* 148 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(129)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(158),
  /* scopeId */
  "data-v-57903db4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(125)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(154),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(130)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(159),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(126)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(155),
  /* scopeId */
  "data-v-15d289f8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(131)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(160),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(127)

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(156),
  /* scopeId */
  "data-v-34a41962",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "experiment"
  }, [_c('div', {
    ref: "renderer",
    staticClass: "experiment__renderer"
  })])
},staticRenderFns: []}

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "modal",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm._onClickClose($event)
      }
    }
  }, [_c('div', {
    ref: "container",
    staticClass: "scroll_container",
    class: {
      'has-scroll-fx': _vm.store.scrollFx, 'has-virtual-scroll': _vm.store.virtualScroll
    }
  }, [_c('div', {
    ref: "inner",
    staticClass: "scroll_inner"
  }, [(_vm.preloaded) ? _c('div', {
    staticClass: "modal__inner",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal__header on-scroll"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.project.title)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.project.description)
    }
  })]), _vm._v(" "), _vm._l((_vm.project.sections), function(section) {
    return _c('div', {
      staticClass: "modal__section on-scroll"
    }, [(section.type == 'image') ? _c('div', [_c('img', {
      attrs: {
        "src": _vm.assetPath + section.url,
        "alt": ""
      }
    }), _vm._v(" "), (section.caption) ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(section.caption)
      }
    }) : _vm._e()]) : (section.type == 'video') ? _c('div', [_c('div', {
      class: {
        'vertical': section.vertical
      }
    }, [(section.url) ? [_c('video', {
      attrs: {
        "src": _vm.assetPath + section.url,
        "alt": "",
        "controls": ""
      }
    })] : _vm._e(), _vm._v(" "), (section.urls) ? [_c('video', {
      attrs: {
        "poster": _vm.assetPath + section.poster,
        "controls": ""
      }
    }, [_c('source', {
      attrs: {
        "src": _vm.assetPath + section.urls.mp4,
        "type": "video/mp4"
      }
    }), _vm._v(" "), _c('source', {
      attrs: {
        "src": _vm.assetPath + section.urls.webm,
        "type": "video/webm"
      }
    })])] : _vm._e(), _vm._v(" "), (section.caption) ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(section.caption)
      }
    }) : _vm._e()], 2)]) : (section.type == 'embed') ? _c('div', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(section.content)
      }
    }), _vm._v(" "), (section.caption) ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(section.caption)
      }
    }) : _vm._e()]) : (section.type == 'text') ? _c('div', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(section.content)
      }
    })]) : _vm._e()])
  })], 2) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "ui-button",
    class: {
      'ui-button--live': _vm.project.live, 'ui-button--soon': _vm.project.soon || _vm.project.no_details
    },
    attrs: {
      "href": (_vm.project.live) ? _vm.project.url : '#',
      "target": "_blank"
    }
  }, [(_vm.project.live) ? _c('span', [_vm._v("See it live")]) : (_vm.project.soon) ? _c('span', [_vm._v("Soon!")]) : (_vm.project.no_details) ? _c('span', [_vm._v("Offline")]) : _c('span', [_vm._v("Screens")])])
},staticRenderFns: []}

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "admin"
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css",
      "integrity": "sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u",
      "crossorigin": "anonymous"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm._onClickDump($event)
      }
    }
  }, [_vm._v("DUMP")]), _vm._v(" "), _c('div', {
    ref: "editor"
  })])
},staticRenderFns: []}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "container",
    staticClass: "scroll_container",
    class: {
      'has-scroll-fx': _vm.store.scrollFx, 'has-virtual-scroll': _vm.store.virtualScroll
    }
  }, [_c('div', {
    ref: "inner",
    staticClass: "scroll_inner"
  }, [_c('section', {
    staticClass: "home"
  }, [_c('header', {
    staticClass: "header section row on-scroll on-scroll--sub",
    attrs: {
      "data-trigger": "{\"header\": true}"
    }
  }, [_c('div', {
    staticClass: "row__side on-scroll__sub"
  }, [_c('h2', [_vm._v(_vm._s(_vm.db.titles.top))])]), _vm._v(" "), _c('div', {
    staticClass: "row__main c-primary on-scroll__sub",
    attrs: {
      "data-scroll": "second"
    }
  }, [_c('div', {
    staticClass: "row__main-left"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.db.general.title)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.db.general.description)
    }
  })])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('section', {
    staticClass: "projects section"
  }, [_c('div', {
    staticClass: "on-scroll"
  }, [_c('h2', [_vm._v(_vm._s(_vm.db.titles.projects))])]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.db.projects), function(project) {
    return _c('li', {
      staticClass: "list__item on-scroll on-scroll--sub"
    }, [_c('project', {
      key: _vm.updateKey,
      attrs: {
        "project": project
      }
    })], 1)
  }))]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.store.isLarge),
      expression: "store.isLarge"
    }],
    staticClass: "projects projects--archives section"
  }, [_c('div', {
    staticClass: "on-scroll"
  }, [_c('h2', [_vm._v(_vm._s(_vm.db.titles.archives))])]), _vm._v(" "), _c('ul', {
    staticClass: "list list--condensed"
  }, _vm._l((_vm.db.archives), function(project) {
    return _c('li', {
      staticClass: "list__item on-scroll on-scroll--sub"
    }, [_c('project', {
      key: _vm.updateKey,
      attrs: {
        "project": project,
        "type": "archive"
      }
    })], 1)
  }))]), _vm._v(" "), _c('section', {
    staticClass: "about section"
  }, [_c('div', {
    staticClass: "on-scroll"
  }, [_c('h2', [_vm._v(_vm._s(_vm.db.titles.about))])]), _vm._v(" "), _c('div', {
    staticClass: "experience"
  }, [_c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.db.experience), function(exp) {
    return _c('li', {
      staticClass: "list__item on-scroll on-scroll--sub"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "row__side row__side--m-50 on-scroll__sub"
    }, [_c('h3', [_vm._v(_vm._s(exp.date))])]), _vm._v(" "), _c('div', {
      staticClass: "row__main row__main--m-50"
    }, [_c('div', {
      staticClass: "row__main-left on-scroll__sub",
      attrs: {
        "data-scroll": "second"
      }
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(exp.description)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "row__main-right on-scroll__sub",
      attrs: {
        "data-scroll": "third"
      }
    }, [_c('p', [_vm._v(_vm._s(exp.location))])])])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "more section row on-scroll on-scroll--sub"
  }, [_c('div', {
    staticClass: "row__side row__side--m-50 list__item on-scroll__sub"
  }, [_c('ul', {
    staticClass: "list list--condensed"
  }, _vm._l((_vm.db.education), function(ed) {
    return _c('li', {
      staticClass: "list__item list__item--flex"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(ed.date)
      }
    }), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(ed.title))]), _vm._v(" "), _c('br'), _vm._v(" " + _vm._s(ed.description))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row__main row__main--m-50 row__main--margin"
  }, [_c('div', {
    staticClass: "row__main-left on-scroll__sub",
    attrs: {
      "data-scroll": "second"
    }
  }, [_c('p', {
    staticClass: "list__item",
    domProps: {
      "innerHTML": _vm._s(_vm.db.about)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row__main-right on-scroll__sub",
    attrs: {
      "data-scroll": "third"
    }
  }, [_c('ul', _vm._l((_vm.db.links), function(link) {
    return _c('li', [_c('a', {
      attrs: {
        "href": link.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link.label))])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "signature section on-scroll",
    domProps: {
      "innerHTML": _vm._s(_vm.logo)
    }
  })])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.store.showModal) ? _c('modal') : _vm._e()], 1), _vm._v(" "), _c('experiment')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header__tip row__side on-scroll__sub"
  }, [_c('span', [_vm._v("↓")]), _vm._v(" "), _c('small', [_vm._v("scroll")])])
}]}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project row",
    class: {
      'project--visited': _vm.visited, 'project--archive': _vm.isArchive, 'row--condensed': _vm.isArchive
    }
  }, [_c('div', {
    staticClass: "row__side c-primary on-scroll__sub"
  }, [(_vm.isArchive) ? _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.project.title)
    }
  }) : _c('h3', {
    ref: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.project.title)
    },
    on: {
      "mouseenter": _vm._onMouseEnter,
      "mouseleave": _vm._onMouseLeave
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row__main projects__item-description"
  }, [_c('div', {
    staticClass: "row__main-left on-scroll__sub",
    attrs: {
      "data-scroll": "second"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.project.description)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.project.extra)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row__main-right on-scroll__sub",
    attrs: {
      "data-scroll": "third"
    }
  }, [_c('ui-button', {
    attrs: {
      "project": _vm.project
    },
    nativeOn: {
      "click": function($event) {
        _vm._onClickButton($event)
      }
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ (function(module, exports) {

module.exports = {
	"title": "DATABASE",
	"type": "object",
	"properties": {
		"general": {
			"type": "object",
			"title": "General",
			"properties": {
				"title": {
					"type": "string"
				},
				"description": {
					"type": "string"
				}
			}
		},
		"titles": {
			"type": "object",
			"title": "Titles",
			"properties": {
				"top": {
					"type": "string"
				},
				"projects": {
					"type": "string"
				},
				"archives": {
					"type": "string"
				},
				"about": {
					"type": "string"
				}
			}
		},
		"projects": {
			"type": "array",
			"format": "tabs",
			"title": "Projects",
			"uniqueItems": true,
			"items": {
				"type": "object",
				"title": "Project",
				"headerTemplate": "{{ i1 }} - {{ self.title }}",
				"properties": {
					"id": {
						"type": "string"
					},
					"title": {
						"type": "string"
					},
					"description": {
						"type": "string"
					},
					"extra": {
						"type": "string"
					},
					"live": {
						"type": "boolean"
					},
					"url": {
						"type": "string"
					}
				}
			},
			"default": []
		},
		"archives": {
			"type": "array",
			"format": "tabs",
			"title": "Archives",
			"uniqueItems": true,
			"items": {
				"type": "object",
				"title": "Project",
				"headerTemplate": "{{ i1 }} - {{ self.title }}",
				"properties": {
					"id": {
						"type": "string"
					},
					"title": {
						"type": "string"
					},
					"description": {
						"type": "string"
					},
					"live": {
						"type": "boolean"
					},
					"url": {
						"type": "string"
					}
				}
			},
			"default": []
		},
		"experience": {
			"type": "array",
			"format": "table",
			"title": "Experience",
			"uniqueItems": true,
			"items": {
				"type": "object",
				"title": "Experience",
				"properties": {
					"date": {
						"type": "string"
					},
					"description": {
						"type": "string"
					},
					"location": {
						"type": "string"
					}
				}
			},
			"default": []
		},
		"education": {
			"type": "array",
			"format": "table",
			"title": "Education",
			"uniqueItems": true,
			"items": {
				"type": "object",
				"title": "Education",
				"properties": {
					"date": {
						"type": "string"
					},
					"title": {
						"type": "string"
					},
					"description": {
						"type": "string"
					}
				}
			},
			"default": []
		},
		"about": {
			"type": "string",
			"format": "textarea"
		},
		"links": {
			"type": "array",
			"format": "table",
			"title": "Links",
			"uniqueItems": true,
			"items": {
				"type": "object",
				"title": "Link",
				"properties": {
					"url": {
						"type": "string"
					},
					"label": {
						"type": "string"
					}
				}
			},
			"default": []
		},
		"modals": {
			"type": "array",
			"title": "Modals",
			"items": {
				"type": "object",
				"title": "Project",
				"headerTemplate": "{{ i1 }} - {{ self.title }}",
				"properties": {
					"id": {
						"type": "string"
					},
					"title": {
						"type": "string"
					},
					"description": {
						"type": "string"
					},
					"sections": {
						"type": "array",
						"items": {
							"type": "object",
							"format": "grid",
							"title": "Section",
							"headerTemplate": "{{ i1 }} - {{ self.type }}",
							"properties": {
								"type": {
									"type": "string",
									"enum": [
										"image",
										"text",
										"slideshow",
										"embed"
									]
								},
								"value": {
									"type": "string"
								}
							}
						}
					}
				}
			}
		}
	}
};

/***/ })
],[73]);


// WEBPACK FOOTER //
// static/js/app.8ebdeeb04f5c7ad79727.js